import React, { FC } from "react";
import AutoLayout from "@src/deprecatedDesignSystem/components/AutoLayout";
import * as RadixPopover from "@radix-ui/react-popover";
import { Button } from "@ui/button";
import Text from "@ui/text";
import { deprecatedTones } from "@src/deprecatedDesignSystem/styles/deprecatedColors";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@ui/tooltip";
import ToggleButton from "@src/deprecatedDesignSystem/components/ToggleButton";
import useTranslationModeContext from "./course/hooks/useTranslationModeContext";
import LanguageSelectorDropdown from "@src/deprecatedDesignSystem/components/LanguageSelectorDropdown";
import { shadows } from "@src/deprecatedDesignSystem/styles/shadows";
import LanguageIcon from "@src/ui/icons/18px/language";

type Props = {
  translationModeEnabled?: boolean;
  setTranslationModeEnabled: (enabled: boolean) => void;
};

const TranslationDropdown: FC<Props> = ({
  translationModeEnabled = false,
  setTranslationModeEnabled,
}) => {
  const translationModeContext = useTranslationModeContext();

  if (!translationModeContext) {
    return null;
  }

  return (
    <RadixPopover.Root>
      <RadixPopover.Trigger asChild>
        <AutoLayout>
          <TooltipProvider>
            <Tooltip>
              <TooltipTrigger asChild>
                <Button
                  size="icon"
                  variant={translationModeEnabled ? "default" : "outline"}
                >
                  <LanguageIcon />
                </Button>
              </TooltipTrigger>
              <TooltipContent side="bottom">Translations</TooltipContent>
            </Tooltip>
          </TooltipProvider>
        </AutoLayout>
      </RadixPopover.Trigger>
      <RadixPopover.Portal>
        <RadixPopover.Content asChild align={"end"}>
          <AutoLayout
            alignSelf={"stretch"}
            direction="vertical"
            flex={1}
            style={{
              zIndex: 15,
              position: "relative",
              boxShadow: shadows.dropdownShadow,
            }}
            width={250}
            backgroundColor={deprecatedTones.white}
            paddingVertical={12}
            paddingHorizontal={16}
            borderRadius={16}
            spaceBetweenItems={8}
          >
            <AutoLayout
              spaceBetweenItems={8}
              flex={1}
              alignSelf="stretch"
              alignmentHorizontal="center"
              spacingMode="space-between"
            >
              <Text type="P2" fontWeight="Medium">
                Translation mode
              </Text>
              <ToggleButton
                onClick={() =>
                  setTranslationModeEnabled(!translationModeEnabled)
                }
                selected={translationModeEnabled}
                type="fill"
              />
            </AutoLayout>
            {translationModeEnabled && (
              <LanguageSelectorDropdown
                selectedLanguage={translationModeContext.translationLanguage}
                onLanguageChange={translationModeContext.setTranslationLanguage}
              />
            )}
          </AutoLayout>
        </RadixPopover.Content>
      </RadixPopover.Portal>
    </RadixPopover.Root>
  );
};

export default TranslationDropdown;
